import React, { useEffect, useRef } from 'react';
import { LiveInstructionSection } from '@scale/shared/types/params/genericdatacollection';
import { makeStyles } from 'react-scale/components/design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import util from '@scale/frontend-lib/util';

// eslint-disable-next-line restrict-imports/restrict-imports
import { Box, Container, Divider, List, ListItem, ListItemText } from '@material-ui/core';

interface LiveInstructionsProps {
  instructions: LiveInstructionSection[];
  currentTimeInSeconds: number;
}

const useStyles = makeStyles(() => ({
  highlightSection: {
    backgroundColor: '#ccffe6',
  },
  normalSection: {},
  container: {
    height: '100%',
    paddingBottom: '15px',
  },
  instructionBox: {
    position: 'relative',
    backgroundColor: '#f2f2f2',
    height: '145px',
    width: '100%',
    overflow: 'scroll',
    borderStyle: 'solid',
  },
  timeUntilStartNumber: {
    paddingLeft: '3px',
  },
}));

const LiveInstructions = (props: LiveInstructionsProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const isMobile = util.isMobileUserAgent(window.navigator.userAgent);
  const classes = useStyles(isMobile);

  const shouldHighlightSection = (section: LiveInstructionSection) => {
    return (
      section.timeStartSeconds <= props.currentTimeInSeconds &&
      section.timeEndSeconds >= props.currentTimeInSeconds
    );
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [scrollRef.current]);

  return (
    <Container className={classes.container}>
      <Box className={classes.instructionBox}>
        <List>
          {props.instructions.map((section, index) => {
            const shouldHighlight = shouldHighlightSection(section);
            return (
              <div
                key={index.toString()}
                className={shouldHighlight ? classes.highlightSection : classes.normalSection}
                ref={shouldHighlight ? scrollRef : undefined}
              >
                <ListItem>
                  <ListItemText primary={section.header} secondary={section.instructions} />
                  {shouldHighlight && <FontAwesomeIcon icon="clock" color={'black'} size={'1x'} />}
                  {shouldHighlight && (
                    <span className={classes.timeUntilStartNumber}>
                      {Math.max(0, section.timeEndSeconds - props.currentTimeInSeconds)}
                    </span>
                  )}
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </Box>
    </Container>
  );
};

export default LiveInstructions;
